module.exports = __webpack_public_path__ + "media/packs/images/search/arrow-e584525f85b8c29b196fd9de27aec47a.svg";